module.exports = __webpack_public_path__ + "img/oufu_60x80x12.prt.c4394d17.jpg";